import React, { useState } from 'react'
import './OrgDetails.css'
import { Radio } from 'antd';
import Shift from './Shift';
import Location from './Location';
import Department from './Department';
import Designation from './Designation';
import LegalEntities from './LegalEntities';
import LeaveType from './LeaveType';
import { useSelector } from 'react-redux';
function OrgDetails() {
    const [size, setSize] = useState("shift");
    const userInfo = useSelector((state) => state.signUp.signUpDetails);
    const handleSizeChange = (e) => {
        setSize(e.target.value);
    };
    return (
        <div className='p-0'>
            <div className='TakerTabs flex !mt-10'>
                <Radio.Group value={size} onChange={handleSizeChange} className='flex flex-wrap'>
                    <Radio.Button value="shift">Shifts</Radio.Button>
                    <Radio.Button value="location" >Locations</Radio.Button>
                    <Radio.Button value="department" >Departments</Radio.Button>
                    <Radio.Button value="designation" >Designations</Radio.Button>
                    {userInfo?.userRole == "businessOwner" &&  <Radio.Button value="legal" >Legal Entities</Radio.Button>}
                    {/* <Radio.Button value="directory" >Directory Settings</Radio.Button>
                    <Radio.Button value="contractor" >Contractor</Radio.Button>
                    <Radio.Button value="holiday" >Holiday Calandar</Radio.Button>
                    <Radio.Button value="leave" >Leave type</Radio.Button> */}
                </Radio.Group>
            </div>
           
            <div>
                {size === 'shift' ? <Shift /> : size === 'location' ? <Location /> : size === 'department' ? <Department /> : 
                size === 'designation' ? <Designation /> : size === 'legal' ? <LegalEntities /> :
                 size === 'leave' ? <LeaveType /> : ''}
            </div>

        </div>
    )
}

export default OrgDetails